import React from 'react';
import { PageHero } from '../components/ui/PageHero';
import { ContactSection } from '../components/sections/ContactSection';
export function Contact() {
  return <>
      <PageHero eyebrow="Contact" title="Reach Dream Shield" subtitle="Schedule a free inspection, ask a question, or call our 24/7 emergency line." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Contact'
    }]} data-id="element-429" data-mp="1qpcuy7l9ynsf" />
      <ContactSection data-id="element-430" data-mp="t2nn3h3w5gyn" />
    </>;
}